// extracted by mini-css-extract-plugin
export default {"inactive":"YkBf3U2phcJZdkTBgq4A","active":"z6YoXB0v_nDNKA5nP9mA"};